/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';


export const SvgDonationEditPost = ({ size }) => {
    return (<Svg
        viewBox="0 0 48 42"
        height={size}
        width={size}
    >
        <G id="Bar-with-caption-box" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-506.000000, -80.000000)" strokeLinecap="round" strokeLinejoin="round">
            <Path d="M548.607189,85.3594756 C546.435883,83.2084939 543.490348,82 540.418936,82 C537.347524,82 534.401989,83.2084939 532.230683,85.3594756 L529.999437,87.5687991 L527.768191,85.3594756 C523.245944,80.8816613 515.913932,80.8816614 511.391685,85.3594757 C506.869438,89.8372901 506.869438,97.0972616 511.391685,101.575076 L513.622931,103.7844 L529.999437,120 L546.375943,103.7844 L548.607189,101.575076 C550.779514,99.4251038 552,96.5085097 552,93.4672758 C552,90.426042 550.779514,87.5094479 548.607189,85.3594756 Z" id="Shape" stroke="#1A1A1A" strokeWidth="3"></Path>
        </G>
    </Svg>)
}

